module.exports = __webpack_public_path__ + "static/media/3DPPA13.4bcae705.jpg";